
<template>
  <div class="modal-backdrop">
     <div class="modal">
        <div class="modal-header">
          <h3>将名单复制到下面文本框中</h3>
			<div class="listHeng" style="position: relative;">
				<a href="javascript:void(0)" style="color:#1d7ad9;" class="listHeng" @mouseover="selectStyle()" @mouseout="outStyle()">有问题,点我!</a>
				<div v-if="showTips" id="nameRule" class="Tips">
					<p><b>规则:</b> 一个客人一行，姓名和证件号使用空格隔开,如：<br>
						<span style="margin-left: 30px;">张三 310101198001015898</span><br><span style="margin-left:30px;">王二 男 G12346578 1980-1-1</span>
					</p>
					<p><b>身份证:</b>只需要姓名和证件号即可,网站可以自动识别身份证中的出生日期和性别,如果出现不能识别,将证件类型改为其他即可</p>
					<p><b>护照:</b>目前识别大多数国家的护照,如果出现部分国家的无法识别,将证件类型改为其他即可</p>
					<p><b>出生日期:</b>目前可识别格式如:1980-7-25,1980/7/25,19800725,1980.7.25,80/7/25,80.7.25,80-7-25,7/25/80,7.25.80,7-25-80</p>
				</div>
			</div>
        </div>
        <div class="modal-body">
            <textarea class="textarea" v-model="mytext" name="" id="" cols="30" rows="10">{{mytext}}</textarea>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            <button type="button" class="btn-confirm" @click="confirm">确认</button>
        </div>
    </div>
 
  </div>
</template>
 
<style>
.Tips{
	width: 500px; 
	/* height: 252px; */
	line-height: 24px; 
	position: absolute; 
	padding: 5px; 
	background: rgb(254, 249, 217); 
	z-index: 999999; 
	color: rgb(140, 57, 1); 
	border: 1px solid rgb(153, 153, 153); 
	font-size: 14px; 
	right: 0px;
	top: 30px;
}
.modal-backdrop { 
    position: fixed; 
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    background-color: rgba(0,0,0,.3); 
    display: flex; 
    justify-content: center; 
    align-items: center; 
}
.modal { 
    background-color: #fff; 
    box-shadow: 2px 2px 20px 1px; 
    overflow-x:auto; 
    display: flex; 
    flex-direction: column;
    border-radius: 16px;
    width: 700px;
} 
.modal-header { 
    border-bottom: 1px solid #eee; 
    color: #313131; 
    justify-content: space-between;
    padding: 15px; 
    display: flex; 
} 
.modal-footer { 
    border-top: 1px solid #eee; 
    justify-content: flex-end;
    padding: 15px; 
    display: flex; 
} 
.modal-body { 
    position: relative; 
    padding: 20px 10px; 
}
.btn-close, .btn-confirm {    
    border-radius: 8px;
    margin-left:16px;
    width:56px;
    height: 36px;
    border:none;
    cursor: pointer;
}
.btn-close {
    color: #313131;
    background-color:transparent;
}
.btn-confirm {
    color: #fff; 
    background-color: #2d8cf0;
}
 
 .textarea{
	 width: 100%;
 }
</style>
 
<script>
import { identifyText } from "../utils/verifyUtils";
export default {
  name: 'Modal',
  props: {  
	insuredInfoList:Array
  },
  data() {
    return {       
		mytext:'',
		showTips:false,
    }
  }, 
  watch:{
  	  insuredInfoList:{
  		  handler(val){
  			  if(val!=this.insuredInfoList){
  				  this.insuredInfoList=val
  			  }
  		  },
  		  immedieta:true,
  	  }
  },
  methods: {  
	  outStyle(){
		  this.showTips = false;
	  },
	  selectStyle(){
		  this.showTips = true;
	  },
    closeSelf() {
        this.$emit("closeme");      
    },
	confirm(){
		if(this.mytext){
			const result = identifyText(this.mytext,this.insuredInfoList)
			if(result && Array.isArray(result) && result.length > 0){
				var rowDatas = result;
				let isExist = false
				const newArray = []
				for (var rowindex = 0; rowindex < rowDatas.length; rowindex++) {
					const rowdata = rowDatas[rowindex]
					const cardIndex = this.insuredInfoList.findIndex(x=>x.insuredIdCardNum == rowDatas[rowindex].insuredIdCardNum)
					if(cardIndex != -1){
						isExist = true
						alert("第" + (cardIndex + 1) + "行已存在,请勿重复插入！")
						break;
					}
					if(rowdata.insuredGender == "M"){
						rowdata.insuredGender = 1
						
					}else{
						rowdata.insuredGender = 2
					}
					if(rowdata.insuredCertificatId == 1){
						rowdata.insuredCertificatId = 0
						rowdata.insuredCertificat = "身份证"
					}else if(rowdata.insuredCertificatId == 2){
						rowdata.insuredCertificatId = 2
						rowdata.insuredCertificat = "护照"
					}else if(rowdata.insuredCertificatId == 3){
						rowdata.insuredCertificatId = 5
						rowdata.insuredCertificat = "其他"
					}
					rowdata.insuredCertificatTypes = 
					[
					  { id: 0, value: "身份证" },
					  { id: 1, value: "军官证" },
					  { id: 2, value: "护照" },
					  { id: 3, value: "驾驶证" },
					  { id: 4, value: "营业执照" },
					  { id: 5, value: "其他" },
					],
					rowdata.showInsuredCertificatPicker = false
					rowdata.showInsuredCalendar = false
					rowdata.minDate = new Date(1900, 1, 1)
					rowdata.currentDate = new Date()
					newArray.push(rowdata)
				}
				if(!isExist){
					this.$emit("confirmTextArea",newArray);
					this.mytext = '';
				}
			}
		}
	}
  }
}
</script>